import "./products.css";
import React, { useState, useRef, useEffect } from "react";
// import { NavLink } from 'react-router-dom';

import lastHope1 from "../images/last_hope/IMG_7064.jpg"
import lastHope2 from "../images/last_hope/IMG_7071.jpg"

import tote1 from "../images/tote-1.png";
import tote2 from "../images/tote-6.png";
import straw from "../images/straw.jpeg";
import stickers from "../images/GGI stickers.png";
import recycle_girl_tshirt from "../images/recycle_girl_tshirt.jpeg";
import raccon_tshirt from "../images/racoon_tshirt.jpeg";
import Product from "../components/Product";
import Bundle from "../components/Bundle";

import earthGirl1 from "../images/earth_girl/IMG_7058.JPG"
import earthGirl2 from "../images/earth_girl/IMG_7059.JPG"
import earthGirl3 from "../images/earth_girl/IMG_7061.JPG"
import factory1 from  "../images/factory/IMG_7065.JPG"
import factory2 from "../images/factory/IMG_7070.JPG"
import leafTrash1 from "../images/leaf_trash/IMG_7073.JPG"
import leafTrash2 from "../images/leaf_trash/IMG_7075.JPG"
import recyleGirl1 from "../images/recycling_girl/IMG_7062.JPG"
import recyleGirl2 from "../images/recycling_girl/IMG_7063.JPG"
import turtle1 from "../images/turtle_plastic/IMG_7076.JPG"
import turtle2 from "../images/turtle_plastic/IMG_7080.JPG"

import rac1 from "../images/raccon_pot/IMG_7078.JPG"
import rac2 from "../images/raccon_pot/IMG_7081.JPG"

import IMAGES from "../images/index.js"

const Products = () => {
  const [openModal, setopenModal] = useState(false);

  const oModal = () => {
    setopenModal(true);
  }

  const cModal = () => {
    setopenModal(false);
  }

  return (
    <>
      <div className="page">
        <div className="content">
          <h1>Products</h1>
          <h4>Here are our current products in stock:</h4>

          <div className="product-grid">
            <Bundle name="Last Hope Tote Bag" imageArray={[lastHope1, lastHope2]} price={11.50} stock="2" description="Cut down on your waste by using a reusable tote bag. 100% cotton"/>
            <Bundle name="Terracotta Factory Pot-llution Tote Bag" imageArray={[factory1, factory2]} price={11.50} stock="6" description="Cut down on your waste by using a reusable tote bag. 100% cotton"/>
            <Bundle name="VSCO Recycling Girl Tote Bag" imageArray={[recyleGirl1, recyleGirl2]} price={11.50} stock="5" description="Cut down on your waste by using a reusable tote bag. 100% cotton"/>
            <Bundle name="Protect Our Earth Girl Tote Bag" imageArray={[earthGirl1, earthGirl2, earthGirl3]} price={11.50} stock="7" description="Cut down on your waste by using a reusable tote bag. 100% cotton"/>
            <Bundle name="Teeturtle Tee - Small" imageArray={[turtle1, turtle2]} price={9.50} stock="3" description="Adult Small. Shirt made of 5% polyester from recycled bottles. Wash inside out to prevent damage."/>
            <Bundle name="Teeturtle Tee - Medium" imageArray={[turtle1, turtle2]} price={9.50} stock="2" description="Adult Medium. Shirt made of 5% polyester from recycled bottles. Wash inside out to prevent damage."/>
            <Bundle name="Nature's Watching T-Shirt - Small" imageArray={[leafTrash1, leafTrash2]} price={9.50} stock="4" description="Adult Small. Shirt made of 5% polyester from recycled bottles. Wash inside out to prevent damage."/>
            <Bundle name="Nature's Watching  T-Shirt - Medium" imageArray={[leafTrash1, leafTrash2]} price={9.50} stock="2" description="Adult Medium. Shirt made of 5% polyester from recycled bottles. Wash inside out to prevent damage."/>
            <Bundle name="Nature's Watching  T-Shirt - Large" imageArray={[leafTrash1, leafTrash2]} price={9.50} stock="1" description="Adult Large. Shirt made of 5% polyester from recycled bottles. Wash inside out to prevent damage."/>
            <Bundle name="Racoon Earth Lovers T Shirt - Small" imageArray={[rac1, rac2]} price={9.50} stock="4" description="Adult Small. Shirt made of 5% polyester from recycled bottles. Wash inside out to prevent damage."/>
            <Bundle name="Racoon Earth Lovers T Shirt - Medium" imageArray={[rac1, rac2]} price={9.50} stock="2" description="Adult Medium. Shirt made of 5% polyester from recycled bottles. Wash inside out to prevent damage."/>

              
              
            {/* <Bundle name="Leaf Tash Tote" imageArray={[IMAGES.earthGirl1, straw, stickers]} price={11.5} stock="40" description="Includes a tote, reusable straw, and stickers. Cut down on your waste by using a reusable tote bag. 100% cotton."/>
            <Bundle name="Leaf Tash Tote" imageArray={[IMAGES.earthGirl1, straw, stickers]} price={15} stock="40" description="Includes a tote, reusable straw, and stickers. Cut down on your waste by using a reusable tote bag. 100% cotton."/>
            <Bundle name="Tote Bag Bundle 2" imageArray={[tote2, straw, stickers]} price={15} stock="40" description="Includes a tote, reusable straw, and stickers. Cut down on your waste by using a reusable tote bag. 100% cotton."/>
            {/* <Product name="Pollution Tote Bag" image={tote1} price={10} stock="13" description="Cut down on your waste by using a reusable tote bag. 100% cotton. Design by Steven Liu. Instagram @fastbird288."/> */}
            {/* <Product name="Recycling Girl Tote" image={tote2} price={10} stock="13" description="Cut down on your waste by using a reusable tote bag. 100% cotton. Design by Colleen Zheng. Instagram @blueebandana."/> */}
            {/* <Product name={`Recycling Girl Shirt`} image={recycle_girl_tshirt} price={8.5} stock="7" description="Shirt made of 5% polyester from recycled bottles. Wash inside out to prevent damage. Design by Colleen Zheng, instagram @blueebandana."/>
            <Product name={`Raccoon T-Shirt`} image={raccon_tshirt} price={9.5} stock="4" description="Shirt made of 5% polyester from recycled bottles. Wash inside out to prevent damage."/>  */}
            {/* <Product name="Pollution Tote Bag" image={tote1} price={10} stock="13" description="Cut down on your waste by using a reusable tote bag. 100% cotton. Design by Steven Liu. Instagram @fastbird288."/>
            <Product name="Recycling Girl Tote" image={tote2} price={10} stock="13" description="Cut down on your waste by using a reusable tote bag. 100% cotton. Design by Colleen Zheng. Instagram @blueebandana."/>
            <Product name={`Reusable Straw and Brush`} image={straw} price={2} stock="4" description="A reusable straw to reduce your plastic use and waste. Comes with a brush to keep clean."/> */}
          </div>
        </div>
      </div>
    </>
  );
};

export default Products;
